import React, { useRef, useState } from 'react';
import { ReactComponent as Plus } from 'assets/icons/button/plus.svg';
import { getTextContent } from 'helpers';

const FAQItem = ({ item }) => {
    const { title, text } = item;
    const [active, setActive] = useState(false);
    const content = useRef(null);
    const [height, setHeight] = useState('0px');

    function toggleAccordion() {
        setActive(!active);
        setHeight(active ? '0px' : `${content.current.scrollHeight}px`);
    }

    return (
        <div className={`faq-item ${active ? '--open' : ''}`} onClick={toggleAccordion}>
            <div className={`faq-item__header `}>
                <div className="description2">{title}</div>
                <div className="faq-item__header-cross">
                    <Plus />
                </div>
            </div>

            <div ref={content} style={{ maxHeight: `${height}` }} className="faq-item__body">
                {text && <div className="body2">{getTextContent(text)}</div>}
            </div>
        </div>
    );
};

export default FAQItem;
